import { CREATE_SHIPMENT_FAILURE, CREATE_SHIPMENT_REQUEST, CREATE_SHIPMENT_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const createShipmentData = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_SHIPMENT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case CREATE_SHIPMENT_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case CREATE_SHIPMENT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default createShipmentData;
